import * as moment from "moment";
import * as komerge from "knockout.merge";
import * as ko from "knockout";
import { DISPLAY_DATE_DEFAULT_FORMAT } from "app/custom-observables";

export default class entityBase {
  constructor() {}

  mergeFromJS = (jsObject: {}) => {
    komerge.fromJS(this, jsObject);
  };

  loadRelation = (source, relation, relationName, relationType = "object") => {
    if (source[relationName]) {
      if (!relationName) {
        throw "Relationship entity '" + relationName + "' needs to be defined in entities.ts.";
      }
      if (Array.isArray(source[relationName])) {
        return ko.observableArray(
          ko.utils.arrayMap(source[relationName], function (c) {
            return new relation(c);
          })
        );
      } else {
        var relationEntity = new relation(source[relationName]);
        if (relationType == "array") {
          return ko.observableArray([relationEntity]);
        } else {
          return ko.observable(relationEntity);
        }
      }
    }
    if (relationType == "array") {
      return ko.observableArray();
    } else {
      return ko.observable(null);
    }
  };

  formatJSONDate = (jsonDate) => {
    let date = ko.isObservable(jsonDate) ? jsonDate() : jsonDate;
    if (!date) {
      return null;
    }
    if (date instanceof Date) {
      return date;
    }
    return moment.utc(date).toDate();
  };

  toDefaultDateString = (date: Date) => {
    return moment(date).format(DISPLAY_DATE_DEFAULT_FORMAT);
  };

  formatStringDate = (date: string) => {
    const dateConverted = this.formatJSONDate(date);
    return this.toDefaultDateString(dateConverted);
  };

  toDateString(date): string {
    if (date) {
      let jsonDate = this.formatJSONDate(date);
      return (
        jsonDate.getFullYear().toString() +
        "-" +
        ("0" + (jsonDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + jsonDate.getDate()).slice(-2) +
        "T" +
        jsonDate.toTimeString().slice(0, 5)
      );
    }
  }
}
